(() => {
  const IMG_SELECTOR = "main img";
  const LIGHTBOX_IMG_CLASS = "behooso-imglightbox";

  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function ensureLightbox() {
    if (document.getElementById("behoosoImgLightbox")) return;

    const wrap = document.createElement("div");
    wrap.id = "behoosoImgLightbox";
    wrap.innerHTML = `
      <div class="bilb__backdrop" aria-hidden="true"></div>
      <div class="bilb__stage" role="dialog" aria-modal="true" aria-label="Image viewer">
        <button class="bilb__close" type="button" aria-label="Close">×</button>
        <img class="bilb__img" alt="" draggable="false" />
      </div>
    `;
    document.body.appendChild(wrap);

    const close = () => wrap.classList.remove("is-open");
    qs(".bilb__backdrop", wrap).addEventListener("click", close);
    qs(".bilb__close", wrap).addEventListener("click", close);

    document.addEventListener("keydown", (e) => {
      if (!wrap.classList.contains("is-open")) return;
      if (e.key === "Escape") close();
    });
  }

  function openLightbox(src, alt) {
    ensureLightbox();
    const wrap = document.getElementById("behoosoImgLightbox");
    const img = qs(".bilb__img", wrap);
    img.src = src;
    img.alt = alt || "";
    wrap.classList.add("is-open");
  }

  // ✅ 你不想套用 lightbox 的，就在這裡排除
  function shouldSkip(img) {
    // 1) Shopify 商品多媒體（避免干擾 product media-gallery）
    if (img.closest("media-gallery, product-media-gallery, .product__media, .media-gallery")) return true;

    // 2) header / logo / icon / favicon 類
    if (img.closest("header, .header, .header__heading, .header__icons, .header__icon")) return true;

    // 3) 你之前 slideshow 的 lightbox（避免打架）
    if (img.closest(".slideshow-section")) return true;

    // 4) 明確標註不要 lightbox 的圖片
    if (img.classList.contains("no-lightbox") || img.closest("[data-no-lightbox='true']")) return true;

    return false;
  }

  // ✅ 方案 B 核心：被 <a> 包住的圖片不加 lightbox class
  function markClickable() {
    qsa(IMG_SELECTOR).forEach((img) => {
      if (!img || shouldSkip(img)) return;

      // 有連結的圖片 → 保留原本連結行為（不套 lightbox）
      if (img.closest("a")) return;

      img.classList.add(LIGHTBOX_IMG_CLASS);
    });
  }

  // 點擊開啟（只吃沒連結的圖片）
  document.addEventListener("click", (e) => {
    const img = e.target.closest(`img.${LIGHTBOX_IMG_CLASS}`);
    if (!img || shouldSkip(img)) return;

    openLightbox(img.currentSrc || img.src, img.alt || "");
  });

  // 初次 + 動態載入（Shopify editor/區塊變動）
  markClickable();
  const mo = new MutationObserver(() => markClickable());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
